exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-bold {\n  font-weight: 600;\n  font-size: 1rem;\n}\n.text-color {\n  font-size: 12px !important;\n  color: rgba(6, 38, 62, 0.84) !important;\n}\n.footer-expense-item {\n  position: fixed;\n  bottom: 0;\n  transform: translateY(-100%);\n  right: 7px;\n  background-color: #f3f4f5;\n  border-top: 1px solid rgba(0, 0, 0, 0.15) !important;\n  width: 100% !important;\n}\n", ""]);

// exports
